/**
 * Shared Firestore query helpers for unit-scoped content lists.
 */

import { GENERAL_UNIT_ID } from '../platform/constants';

/** Unit ids visible to the current user (non-admin). */
export function getVisibleUnitIds(user) {
  if (!user?.unit) {
    return [GENERAL_UNIT_ID];
  }
  return [GENERAL_UNIT_ID, user.unit];
}
